module.exports = __webpack_public_path__ + "img/img3.008d6462.svg";